export default "__VITE_ASSET__bc0b182f__"